/*
 * (c) Copyright Reserved EVRYTHNG Limited 2022. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

/**
 * Exchange Operator's API key for Shield access token.
 *
 * @param {string} apiUrl - Current EVRYTHNG API URL.
 * @param {string} apiKey - Operator API Key or Access Token with shieldAuth permission.
 * @returns {string} Shield access token.
 */
export const getShieldAccessToken = async (apiUrl, apiKey) => {
  const { access_token: accessToken } = await fetch(
    `${apiUrl}/shield/accessToken?scopes=des-json`,
    {
      headers: { Authorization: apiKey },
    },
  ).then(r => r.json());
  return accessToken;
};
